<template>
  <div>
    <div :class="`dropdown-overlay ${open ? 'open' : 'close'}`" @click="onClose"></div>
    <nav :class="`dropdown ${open ? 'open' : ''}`">
      <ul>
        <li v-for="action in actions" :key="action.type" @click="handleAction(action)">
          <span v-if="action.type === 'Postpone'">Reporter la visite</span>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'ListDropdown',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    actions: {
      type: Array,
      default: () => []
    },
    onDelete: {
      type: Function,
      default: () => null
    },
    onPostpone: {
      type: Function,
      default: () => null
    },
    onClose: {
      type: Function,
      default: () => null
    }
  },
  methods: {
    handleAction(action) {
      if (action.type === 'Postpone') {
        this.onPostpone()
      } else if (action.type === 'Delete') {
        this.onDelete()
      }
    }
  }
}
</script>
